import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Spin } from 'antd';
import AdminLayout from './layouts/AdminLayout';
import { TOKEN_KEY } from './api/client';

// 懒加载页面组件，按需分包
const Login = lazy(() => import('./pages/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const VodList = lazy(() => import('./pages/VodList'));
const VodCreate = lazy(() => import('./pages/VodCreate'));
const VodFilter = lazy(() => import('./pages/VodFilter'));
const TypeList = lazy(() => import('./pages/TypeList'));
const UserList = lazy(() => import('./pages/UserList'));
const ArtList = lazy(() => import('./pages/ArtList'));
const TopicList = lazy(() => import('./pages/TopicList'));
const CollectList = lazy(() => import('./pages/CollectList'));
const AdList = lazy(() => import('./pages/AdList'));
const CommentList = lazy(() => import('./pages/CommentList'));
const GbookList = lazy(() => import('./pages/GbookList'));
const SystemConfig = lazy(() => import('./pages/SystemConfig'));
const PlayerList = lazy(() => import('./pages/PlayerList'));
const LinkList = lazy(() => import('./pages/LinkList'));

/** 页面加载占位 */
function PageFallback() {
  return (
    <div style={{ padding: 48, textAlign: 'center' }}>
      <Spin tip="加载中..." />
    </div>
  );
}

/** 鉴权路由：未登录跳转到登录页 */
function ProtectedLayout() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <AdminLayout />;
}

export default function App() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        {/* 登录页独立于后台布局 */}
        <Route path="/login" element={<Login />} />

        {/* 后台主体布局，包含鉴权校验 */}
        <Route path="/" element={<ProtectedLayout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />

          {/* 视频管理 */}
          <Route path="vod/list" element={<VodList />} />
          <Route path="vod/create" element={<VodCreate />} />
          <Route path="vod/filter" element={<VodFilter />} />

          {/* 内容管理 */}
          <Route path="type/list" element={<TypeList />} />
          <Route path="user/list" element={<UserList />} />
          <Route path="art/list" element={<ArtList />} />
          <Route path="topic/list" element={<TopicList />} />
          <Route path="collect/list" element={<CollectList />} />
          <Route path="ad/list" element={<AdList />} />
          <Route path="comment/list" element={<CommentList />} />
          <Route path="gbook/list" element={<GbookList />} />

          {/* 系统 */}
          <Route path="system/config" element={<SystemConfig />} />
          <Route path="player/list" element={<PlayerList />} />
          <Route path="link/list" element={<LinkList />} />

          {/* 兜底：未匹配路由跳转到仪表盘 */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
